import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import { Container, Typography, styled, Box } from '@mui/material';
import { ChangePassword } from '../sections/auth/login';

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '80vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

export default function UserChangePassword() {

  return (
    <>
      <Helmet>
        <title> DV Agent </title>
      </Helmet>
      <Container maxWidth="xxl">
        <Typography color="text.secondary" sx={{ fontSize: 22, fontWeight: 'bold', textAlign:"center" }}>
          Change your password
        </Typography>
      </Container>
        <Container maxWidth="sm">
          <StyledContent>
            <ChangePassword/>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:50 }}>
              <Box to="/" component={RouterLink}>
                <img width={20} src="../../assets/back-button.gif" alt="back" />
              </Box>
              <Typography
                to="/" component={RouterLink}
                gutterBottom
                variant=""
                sx={{
                  marginTop:1,
                  fontSize: 16,
                  textDecoration: 'none',
                  color: "#A8A196"
                }}
              >
                Back to Home
              </Typography>
            </div>
            <Typography color="text.secondary" sx={{ mb: 2, mt:5, fontSize: 18, fontWeight: 'bold' }}>
                Password Instructions-
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 1, fontSize: 14 }}>
                1. &nbsp;Password should be alphanumeric.
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 1, fontSize: 14 }}>
                2. First letter of the password should be capital.
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 1, fontSize: 14 }}>
                3. Password length must be greater than 8 characters.
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 1, fontSize: 14 }}>
                4. Password should have any one of the special characters @, $, %, *.
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 1, fontSize: 14 }}>
                5. Password field should not be empty.
            </Typography>
          </StyledContent>
        </Container>
    </>
  );
}